(function () {
    'use strict';

    angular
        .module('procedureControllers', [
            'services.language'
        ]);


    /**
     * Defines all the types used in the module, for ease of validation and auto-complete
     *
     * @typedef {object} Procedure
     * @property {FootnoteBlock} FootnoteBlock
     * @property {MetadataBlock} MetadataBlock
     * @property {object} ReferenceBlock
     * @property    {Reference[]} ReferenceBlock.References
     * @property {ReviewerBlock} ReviewerBlock
     * @property {ParticipantBlock} ParticipantBlock
     * @property {LookupAttributeValue} ProgressStatus
     * @property {SectionBlock[]} SectionBlocks
     * @property {Person[]} Owners
     * @property {Person[]} Readers
     * @property {TableOfContentsBlock[]} TableOfContents
     * @property {number} Version
     *
     * @typedef {object} FootnoteBlock
     * @property {string} Anchor
     * @property {Footnote[]} Footnotes
     * @property {boolean} IsDynamic
     * @property {string} TitleEN
     *
     * @typedef {object} Footnote
     * @property {string} Code
     * @property {string} ContentHtml
     *
     * @typedef {object} MetadataBlock
     * @property {string} Anchor
     * @property {bool} IsCorporate
     * @property {object} IssuerBusinessUnit
     * @property {number} IssuerBusinessUnitID
     * @property {array} LegalEntities
     * @property {array} Locations
     * @property {number} MetadataBlockID
     * @property {string} Objectives
     * @property {ProcedureCode} ProcedureCode
     * @property {LookupAttributeValue} ProcedureType
     * @property {string} ShortDescription
     * @property {string} TitleEN
     *
     * @typedef {object} ReviewerBlock
     * @property {string} Anchor
     * @property {boolean} IsDynamic
     * @property {array} Reviewers
     * @property {string} TitleEN
     *
     * @typedef {object} ParticipantBlock
     * @property {string} Anchor
     * @property {boolean} IsDynamic
     * @property {array} Participants
     * @property {array} Responsibilities
     * @property {array} Stakeholders
     * @property {string} TitleEN
     *
     * @typedef {object} ProcedureCode
     * @property {string} Code
     * @property {number} CodeNumber
     * @property {string} CodePrefix
     *
     * @typedef {object} Reference
     * @property {string} TypeCode
     *
     * @typedef {object} Responsibility
     * @property {BusinessUnit} BusinessUnit
     * @property {LookupAttributeValue} LookupAttributeValue
     * @property {number} ResponsibilityID
     * @property {string} TitleEN
     *
     * @typedef {object} ReviewerBlock
     * @property {string} Anchor
     * @property {boolean} IsDynamic
     * @property {array} ExcludedReviewers
     * @property {string} TitleEN
     * @property {array} Reviewers
     *
     * @typedef {object} SectionBlock
     * @property {array} AttachmentReferences
     * @property {array} BusinessUnitReferences
     * @property {string} Content
     * @property {string} ContentHtml
     * @property {array} ControlReferences
     * @property {array} CommitteeReferences
     * @property {array} CorporateRoleReferences
     * @property {array} ImageAttachments
     * @property {boolean} IsAppendix
     * @property {array} Footnotes
     * @property {number} Level
     * @property {array} LookupReferences
     * @property {string} Number
     * @property {array} ProcedureReferences
     * @property {SectionBlockResponsibility} Responsibility
     * @property {number} SectionBlockID
     * @property {number} SectionBlockMasterID
     * @property {string} TitleEN
     *
     * @typedef {object} SectionBlockResponsibility
     * @property {object} BusinessUnit
     * @property {object} LookupAttributeValue
     * @property {string} ResponsibilityTitleEN
     *
     * @typedef {object} TableOfContentsBlock
     * @property {string} Anchor
     * @property {boolean} IsDynamic
     * @property {string} Number
     * @property {string} TitleEN
     */

})();